<app-loader *ngIf="!authService?.profileUpdated()" [type]="'full-page'" [visible]="true" [background]="true"></app-loader>
<div class="qatch-app">
    <router-outlet *ngIf="authService?.isReady()"></router-outlet>
    <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
</div>